export const selectLocationState = (state) => state.location;

export const selectUserLocation = (state) => state.location.location;

export const selectShouldShowLocationPrompt = (state) => {
  const { location, permissionStatus, promptDismissed } =
    state.location;

  return (
    !location &&
    permissionStatus !== "granted" &&
    !promptDismissed
  );
};